<form class="form-popup" [formGroup]="formGroup">
 <div class="modal-header">
    <b>Enter Rebuttal Comment</b>
  </div>

  <div class="modal-body">
    <mat-form-field appearance="fill" class="editable-text-field" >
      <textarea matInput rows="6" formControlName="rebuttalComment"></textarea>
    </mat-form-field>
  </div>

</form>
